export default __webpack_public_path__ + "static/media/__link__icon__leftmenubar.23fe1e5d.svg";